{
  "name": "@transak/react-native-sdk",
  "version": "2.1.0",
  "description": "A React Native SDK for decentralised applications to onboard their global user base with fiat currency",
  "type": "module",
  "types": "lib/index.d.ts",
  "main": "lib/index.cjs",
  "exports": {
    ".": {
      "import": {
        "types": "./lib/index.d.ts",
        "default": "./lib/index.js"
      },
      "require": {
        "types": "./lib/index.d.cts",
        "default": "./lib/index.cjs"
      }
    }
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "packageManager": "pnpm@9.5.0+sha512.140036830124618d624a2187b50d04289d5a087f326c9edfc0ccd733d76c4f52c3a313d4fc148794a2a9d81553016004e6742e8cf850670268a7387fc220c903",
  "files": [
    "lib/**/*"
  ],
  "scripts": {
    "eslint": "eslint . --ext .ts,.tsx",
    "eslint:fix": "pnpm eslint --fix",
    "build": "tsc && tsup",
    "prepack": "pnpm build",
    "packDev": "pnpm pack"
  },
  "author": "Transak",
  "license": "ISC",
  "homepage": "https://docs.transak.com/docs/react-native-integration#transak-react-native-sdk",
  "repository": {
    "type": "git",
    "url": "https://github.com/Transak/react-native-sdk"
  },
  "peerDependencies": {
    "@react-native-community/netinfo": "*",
    "@types/react": "*",
    "react": "*",
    "react-native": "*",
    "react-native-inappbrowser-reborn": "*",
    "react-native-webview": "*"
  },
  "dependencies": {
    "pako": "^2.1.0",
    "pusher-js": "^8.3.0",
    "query-string": "^8.2.0"
  },
  "devDependencies": {
    "@types/pako": "^2.0.3",
    "@types/react": "^18.2.57",
    "eslint": "^8.56.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^17.1.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-eslint-comments": "^3.2.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-no-relative-import-paths": "^1.5.3",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-promise": "^6.1.1",
    "prettier": "^3.2.5",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3"
  },
  "keywords": [
    "crypto",
    "cryptocurrency",
    "fiat",
    "on",
    "off",
    "ramp",
    "sdk",
    "react-native"
  ]
}
